export default __webpack_public_path__ + "static/media/service3.bded4f8e.png";